import React from 'react';
import { ExpandableContent } from '@ax2/common/components/ExpandableContent';
import styles from '@/styles/components/expandable/ExpandableQuestion.module.css';
import { scroller, Events } from 'react-scroll';

export interface ExpandableReportData {
  id: string;
  title: string;
  subtitle: string;
  previewContent: JSX.Element;
  expandedContent: JSX.Element;
}

export const ExpandableReport: React.FC<ExpandableReportData> = props => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  return (
    <div className={styles.expandableQuestion} id={props.id}>
      <ExpandableContent
        title={props.title}
        subtitle={props.subtitle}
        expandLabel="Show"
        reduceLabel="Hide"
        actions={[]}
        previewContent={props.previewContent}
        expandedContent={props.expandedContent}
        isExpanded={isExpanded}
        onExpand={async isExpanded => {
          return new Promise(resolve => {
            Events.scrollEvent.register('end', to => {
              if (to === props.id) {
                Events.scrollEvent.remove('end');
                resolve();
              }
            });
            scroller.scrollTo(props.id, {
              duration: 400,
              delay: 0,
              smooth: 'easeInOutQuart',
            });
          }).then(() => setIsExpanded(isExpanded));
        }}
      />
    </div>
  );
};
